export default __webpack_public_path__ + "b05708421c74abb1f30c8a5da9f99fe1.png";